module.exports = __webpack_public_path__ + "static/work_Google_Arts_And_Culture_clip-ccbb181ab037bb0b2a3f5efc2a4c673f.jpeg";